import script from "./BillingDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./BillingDashboard.vue?vue&type=script&setup=true&lang=js"

import "./BillingDashboard.vue?vue&type=style&index=0&id=c4c70e18&lang=css"

const __exports__ = script;

export default __exports__